import { createStore } from "redux";
import rotateReducer from "../reducers/rotateReducer";

const STORAGE_KEY = "inspection-context";
const DEFAULT_STATE = { rotating: true };

const loadState = () => {
  try {
    const saved = sessionStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : DEFAULT_STATE;
  } catch (e) {
    return DEFAULT_STATE;
  }
};

function configureStore(state = loadState()) {
  const store = createStore(rotateReducer, state);

  store.subscribe(() => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(store.getState()));
    } catch (e) {
    }
  });

  return store;
}

export default configureStore;
